import React from 'react';
import {useNavigate} from "react-router-dom";
import "./index.scss"
import * as R from "../../../../common/routes";

const LoggingMenu = () => {
    const navigate = useNavigate();
    return (
        <ul className={"loggingMenu"}>
            <li
                onClick={() => navigate(R.LOGGING_MESSAGES)}
                className={"menuItem"}>Messages
            </li>
            <li
                onClick={() => navigate(R.LOGGING_EXCEPTIONS)}
                className={"menuItem"}>Exceptions
            </li>
            <li
                onClick={() => navigate(R.LOGGING_CONNECTIONS)}
                className={"menuItem"}>Connections
            </li>
        </ul>
    );
};

export default LoggingMenu;
